import { StateCreator } from 'zustand';

export type StatusDialogState = 'loading' | 'success' | 'error';

interface StatusDialogErrorActions {
    confirmText?: string;
    cancelText?: string;
    onConfirm?: () => void;
    onCancel?: () => void;
}

interface StatusDialogPayload {
    heading: string;
    message?: string;
    closable?: boolean;
    actions?: StatusDialogErrorActions;
}

export interface StatusDialogData extends StatusDialogPayload {
    status: StatusDialogState;
    open: boolean;
}

export interface StatusDialogSlice {
    statusDialog: StatusDialogData;

    showStatusLoading: (payload: Omit<StatusDialogPayload, 'actions'> & { closable?: boolean }) => void;

    showStatusSuccess: (payload: Omit<StatusDialogPayload, 'actions'>) => void;

    showStatusError: (payload: StatusDialogPayload) => void;

    updateStatusDialog: (patch: Partial<StatusDialogPayload & { status: StatusDialogState }>) => void;

    closeStatusDialog: () => void;
}
const DEFAULT_STATE: StatusDialogData = {
    open: false,
    status: 'loading',
    heading: '',
    message: undefined,
    closable: true,
    actions: undefined
};
export const createStatusDialogSlice: StateCreator<StatusDialogSlice> = (set) => ({
    statusDialog: DEFAULT_STATE,

    showStatusLoading: (payload) =>
        set({
            statusDialog: {
                ...DEFAULT_STATE,
                ...payload,
                status: 'loading',
                closable: payload.closable ?? false,
                open: true
            }
        }),

    showStatusSuccess: (payload) =>
        set({
            statusDialog: {
                ...DEFAULT_STATE,
                ...payload,
                status: 'success',
                closable: payload.closable ?? true,
                open: true
            }
        }),

    showStatusError: (payload) =>
        set({
            statusDialog: {
                ...DEFAULT_STATE,
                ...payload,
                status: 'error',
                closable: payload.closable ?? true,
                open: true
            }
        }),

    updateStatusDialog: (patch) =>
        set((state) => ({
            statusDialog: { ...state.statusDialog, ...patch }
        })),

    closeStatusDialog: () =>
        set((state) => ({
            statusDialog: { ...state.statusDialog, open: false }
        }))
});
